/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 45);
/******/ })
/************************************************************************/
/******/ ({

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var angular = require('angular');
// var _ = require('lodash');

(function () {
    'use strict';

    angular.module('app').config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/history', {
            templateUrl: 'assets/history/history.html',
            controller: 'HistoryController',
            controllerAs: 'vm',
            authorize: true
        });
    }]).controller('HistoryController', historyController);

    historyController.$inject = ['$scope', '$location', '$localStorage', '$sessionStorage', '$interval', '$filter', '$document', '$timeout', 'configBaseLayers', 'configHistoryLayers', 'leafletData', 'markerService', 'emissionControlAreaService', 'vesselService'];

    function historyController($scope, $location, $localStorage, $sessionStorage, $interval, $filter, $document, $timeout, configBaseLayers, configHistoryLayers, leafletData, markerService, emissionControlAreaService, vesselService) {

        var vm = this;

        // build initial view and leaflet model
        var storage = $localStorage.$default({
            center: {
                lat: 50,
                lng: 10,
                zoom: 4
            }
        });

        var toDate = new Date();
        angular.extend(vm, {
            error: '',
            clearLastError: function clearLastError() {
                vm.error = '';
            },
            refreshInSeconds: 0,
            historySidebarActive: true,
            selectedVessel: null,
            historyItems: [],
            $storage: storage,
            defaults: {
                minZoom: 2,
                worldCopyJump: true
            },
            controls: {},
            availableVessels: [],
            layers: configBaseLayers(),
            paths: {},
            markers: {},
            events: { // http://leafletjs.com/reference-1.2.0.html#map-event
                marker: {
                    enable: ['mouseover'],
                    logic: "emit"
                },
                path: {
                    enable: ['mouseover'],
                    logic: "emit"
                }
            },
            closeHistorySidebar: function closeHistorySidebar() {
                vm.historySidebarActive = false;
            },
            buildHistorySource: function buildHistorySource() {
                vm.historyItems = _.sortBy(vm.historyItems, [function (i) {
                    return i.vessel.description;
                }]);
                vm.historyList = _.groupBy(vm.historyItems, function (i) {
                    return i.vessel.description;
                });
            },
            addHistoryItem: function addHistoryItem() {
                if (!vm.selectedVessel) return;
                var toDate = new Date();
                var fromDate = new Date(toDate - 864000000); // default 10 days in past
                vm.historyItems.push({
                    vessel: angular.copy(vm.selectedVessel),
                    minFrom: new Date(vm.selectedVessel.minFromDate),
                    from: fromDate,
                    to: toDate,
                    color: '#16813d'
                });

                // sort by vessel description
                vm.buildHistorySource();
                vm.selectedVessel = null;
                vm.setAvailableVessels();
            },
            removeHistoryItem: function removeHistoryItem(currentItem) {
                vm.historyItems = _.filter(vm.historyItems, function (item) {
                    return item !== currentItem;
                });
                vm.buildHistorySource();
                vm.selectedVessel = null;
                vm.setAvailableVessels();
            },
            copyHistoryItem: function copyHistoryItem(item) {
                if (!item) return;
                var toDate = new Date();
                var fromDate = new Date(toDate - 864000000); // default 10 days in past
                vm.historyItems.push({
                    vessel: item.vessel,
                    minFrom: item.minFrom,
                    from: fromDate,
                    to: toDate,
                    color: item.color
                });
                vm.buildHistorySource();
            },
            removeHistoryItems: function removeHistoryItems() {
                vm.historyItems = [];
                vm.buildHistorySource();
                vm.selectedVessel = null;
                vm.setAvailableVessels();
            },
            setAvailableVessels: function setAvailableVessels() {
                if (vm.historyItems.length === 0) vm.availableVessels = vm.vessels;else vm.availableVessels = _.filter(vm.vessels, function (v) {
                    return _.every(vm.historyItems, function (i) {
                        return i.vessel.code !== v.code;
                    });
                });
                vm.availableVessels = _.sortBy(vm.availableVessels, [function (i) {
                    return i.description;
                }]);
            },
            refreshView: function refreshView() {
                vm.error = '';

                // relevant part of view model is: vm.historyItems
                leafletData.getMap().then(function (map) {
                    vm.markers = {};
                    vm.paths = [];
                    markerService.getHistoricalMarkersAndPaths(vm.historyItems).then(function (result) {
                        vm.markers = result.markers;
                        vm.paths = result.paths;
                    }).catch(function (e) {
                        var message = e;
                        // openweathermap.org
                        if (e.data && e.data.cod && e.data.message) {
                            message = e.data.message;
                        }
                        // softship web services
                        if (e.data && e.data.Message) {
                            message = e.data.Message;
                        }

                        vm.error = 'unable to get markers: ' + message;
                    });
                });
            },
            getVoyages: function getVoyages(vesselCode, searchValue) {
                return vesselService.getCurrentVoyages(vesselCode, searchValue | '');
            },
            dateOptions: {
                dateDisabled: false,
                formatYear: 'yy',
                maxDate: toDate,
                minDate: new Date(toDate - 8640000000), // 100 days in past
                startingDay: 1
            },
            fromDateOpen: function fromDateOpen(item) {
                vm.dateOptions.minDate = item.minFrom;
                item.fromDateOpen = true;
            },
            toDateOpen: function toDateOpen(item) {
                vm.dateOptions.minDate = item.minFrom;
                item.toDateOpen = true;
            },
            colorOptions: {
                required: true,
                swatchOnly: true,
                pos: 'bottom right'
            },
            formatDate: function formatDate(date) {
                return $filter('date')(date, "MM/dd/yyyy HH:mm");
            },
            setFocus: function setFocus(voyage, controlId) {
                var isFrom = controlId.indexOf('fromDate') !== -1;
                if (isFrom) voyage.from = '';else voyage.to = '';
                $timeout(function () {
                    $document[0].getElementById(controlId).focus();
                }, 500);
            }
        });

        emissionControlAreaService.getEmissionControlAreas().then(function (data) {
            var layers = configHistoryLayers(data);
            vm.layers = layers;
        }).catch(function (e) {
            vm.error = 'unable to config layers: ' + e;
        });

        // create event handlers
        // path point tooltip
        $scope.$on('leafletDirectivePath.historyMap.mouseover', function (event, path) {
            if (path.leafletObject.options.tooltip) {
                path.leafletObject.bindTooltip(path.leafletObject.options.tooltip).openTooltip();
                path.leafletObject.options.tooltip = '';
            }
        });

        // harbour, vessel tooltip
        $scope.$on('leafletDirectiveMarker.historyMap.mouseover', function (event, marker) {
            if (marker.leafletObject.options.tooltip) {
                marker.leafletObject.bindTooltip(marker.leafletObject.options.tooltip).openTooltip();
                marker.leafletObject.options.tooltip = '';
            }
        });

        // initial load / reload  harbour and vessel markers every 60 seconds
        var refreshIntervalInSeconds = 60;
        vm.refreshInSeconds = refreshIntervalInSeconds;
        $interval(function () {
            if (vm.refreshInSeconds === refreshIntervalInSeconds) {
                vm.error = '';
                leafletData.getMap().then(function (map) {
                    // check for new vessels each minute
                    vm.vessels = vesselService.getVesselsHavingWaypoints().then(function (result) {
                        vm.vessels = result.d.vessels;
                        vm.setAvailableVessels();
                        // only once, otherwise they are created several times and shown more than once in map!
                        if (!vm.controls.scale) {
                            // waypoints control only for SeaMap Admin (1001)
                            if ($sessionStorage.logonInfo.security.hasAdminRole) {
                                vm.controls = {
                                    scale: true,
                                    custom: markerService.createHistoryWaypointsControl()({
                                        position: 'topright'
                                    })
                                };
                            } else vm.controls = { scale: true };
                        }
                    }).catch(function (e) {
                        var message = e;
                        // softship web services
                        if (e.data && e.data.Message) {
                            message = e.data.Message;
                        }

                        vm.error = 'unable to get vessels: ' + message;
                    });
                });
                vm.refreshInSeconds = 0;
            } else {
                vm.refreshInSeconds += 1;
            }
        }, 1000);
    }
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// historyController_f61149ed4534c2438558.js